<template>
  <div>
    <v-col cols="12" style="text-align: right">
      <template v-if="groupID == undefined">
        <v-btn
          color="success"
          v-if="
            prodGroupData.group_name != '' &&
            prodGroupData.product_codes.length > 0 &&
            showBtn &&
            roles.create_product_group
          "
          @click="saveData"
          >CREATE</v-btn
        >
        <v-btn v-else disabled>CREATE</v-btn>
      </template>
      <template v-if="groupID != undefined">
        <v-btn
          color="info"
          v-if="
            prodGroupData.group_name != '' &&
            prodGroupData.product_codes.length > 0 &&
            showBtn &&
            roles.update_product_group
          "
          @click="saveData"
          >EDIT</v-btn
        >
        <v-btn v-else disabled>EDIT</v-btn>
      </template>
      <!-- &nbsp;<v-btn color="pink" @click="check">CHECK</v-btn> -->
      &nbsp;
      <v-btn color="orange" dark @click="cancelData">CANCEL</v-btn>
    </v-col>

    <v-alert type="error" v-if="informText != ''">
      {{ informText }}
    </v-alert>

    <v-col cols="12">
      <v-col cols="12">
        <v-row>
          <v-col cols="5">
            <v-text-field
              dense
              outlined
              label="Product Group Name"
              v-model="prodGroupData.group_name"
              @keyup="validation"
              @mouseup="validation"
            ></v-text-field>
          </v-col>
          <v-col cols="5">
            <v-text-field
              dense
              outlined
              v-model="inputProduct"
              @keyup.enter="
                addProduct();
                validation();
              "
              label="Product Code"
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-btn
              color="purple"
              dark
              @click="
                addProduct();
                validation();
              "
              >Add</v-btn
            >
          </v-col>
        </v-row>
      </v-col>

      <table
        width="100%"
        class="table table-bordered"
        v-if="listThumb.length == 0"
      >
        <tr v-for="(a, indexa) of prodGroupData.product_codes" :key="indexa">
          <td>{{ a }}</td>
          <td>
            <v-btn color="orange" small dark @click="delProduct(a)"
              ><v-icon>mdi-delete</v-icon></v-btn
            >
          </td>
        </tr>
      </table>

      <v-row v-else>
        <v-col cols="6" v-for="(b, indexb) of listThumb" :key="indexb">
          <v-row>
            <v-col cols="4" class="border">
              <img
                :src="b.thumbnail"
                style="width: 250px"
                v-if="b.thumbnail != ''"
              />
              <img
                v-else
                src="https://ctkbiotech.com/wp/wp-content/uploads/2018/03/not-available.jpg"
                style="width: 250px"
              />
            </v-col>
            <v-col cols="8" class="border" style="text-align: left">
              <p>
                <b>{{ b.product_id_data }}</b>
              </p>
              <p>{{ b.title }}</p>
              <div>
                <v-btn color="orange" small dark @click="delProduct(b)"
                  ><v-icon>mdi-delete</v-icon></v-btn
                >
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<script>
import axios from "axios";
import Amplify from "aws-amplify";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "ProductGroupAction",
  props: {
    groupID: String,
  },
  data: () => ({
    showBtn: true,
    prodGroupData: {
      group_id: "",
      group_name: "",
      product_codes: [],
    },
    listThumb: [],
    informText: "",
    inputProduct: "",
    loading: false,
    roles: [],
  }),

  methods: {
    check() {
      console.log("prodGroupData: ", this.prodGroupData);
      console.log("listThumb: ", this.listThumb);
    },

    addProduct() {
      if (this.inputProduct != "") {
        var index = this.prodGroupData.product_codes.indexOf(this.inputProduct);

        if (index < 0) {
          this.prodGroupData.product_codes.push(
            JSON.parse(JSON.stringify(this.inputProduct))
          );

          if (this.listThumb.length > 0) {
            var item = {
              product_id: JSON.parse(JSON.stringify(this.inputProduct)),
              thumbnail: "",
              title: "",
              _id: "",
            };
            this.listThumb.push(item);
          }
        }
      }

      this.inputProduct = "";
    },

    delProduct(product) {
      console.log("product: ", product);
      if (typeof product == "string") {
        console.log("TRUE");
        var indexStr = this.prodGroupData.product_codes.indexOf(product);
        this.prodGroupData.product_codes.splice(indexStr, 1);
      } else {
        console.log("FALSE");
        var indexObj = this.listThumb.indexOf(product);
        this.listThumb.splice(indexObj, 1);
        indexStr = this.prodGroupData.product_codes.indexOf(product);
        this.prodGroupData.product_codes.splice(indexStr, 1);
      }
      this.validation();
    },

    cancelData() {
      this.$root.$refs.productGroup.turnOffDialog();
    },

    async loadData() {
      this.loading = true;
      var currentSession = await this.$root.$refs.App.currentSession(
        "product-group-loadData"
      );
      //console.log('currentSession: ',currentSession.accessToken)
      if (currentSession.accessToken) {
        await axios
          .get(window.domain + "product-groups/" + this.groupID, {
            headers: { Authorization: currentSession.accessToken },
          })
          .then((response) => {
            console.log("response: ", response);
            if (response.data.error_message == "") {
              console.log(response.data.data);
              this.prodGroupData = response.data.data.product_group;
              this.listThumb = response.data.data.thumbnails;

              for (var a of this.listThumb) {
                for (var b of this.prodGroupData.product_codes) {
                  if (b.indexOf(a.product_id) > -1) {
                    console.log("TRUE");
                    a["product_id_data"] = b;
                  }
                }
              }
            } else {
              this.informText = response.data.error_message;
            }

            this.loading = false;
          })
          .catch((error) => {
            console.log("error ", error);
          });
      } else {
        console.log(
          "currentSession product-group-loadData-undefined: ",
          currentSession
        );
      }
    },

    async saveData() {
      this.showBtn = false;
      var currentSession = await this.$root.$refs.App.currentSession(
        "product-group-loadData"
      );

      if (this.groupID != undefined) {
        //EDIT
        console.log("EDIT");
        if (currentSession.accessToken) {
          await axios({
            method: "put",
            url: window.domain + "product-groups/" + this.groupID,
            data: this.prodGroupData,
            headers: { Authorization: currentSession.accessToken },
          })
            .then((response) => {
              console.log("response: ", response);
              if (response.data.error_message == "") {
                this.cancelData();
              } else {
                this.informText = response.data.error_message;
                this.showBtn = true;
              }
            })
            .catch((error) => {
              console.log("error ", error);
            });
        } else {
          console.log(
            "currentSession product-group-loadData-undefined: ",
            currentSession
          );
        }
      } else {
        //CREATE
        console.log("CREATE");
        if (currentSession.accessToken) {
          await axios({
            method: "post",
            url: window.domain + "product-groups",
            data: this.prodGroupData,
            headers: { Authorization: currentSession.accessToken },
          })
            .then((response) => {
              console.log("response: ", response);
              if (response.data.error_message == "") {
                this.cancelData();
              } else {
                this.informText = response.data.error_message;
                this.showBtn = true;
              }
            })
            .catch((error) => {
              console.log("error ", error);
            });
        } else {
          console.log(
            "currentSession product-group-loadData-undefined: ",
            currentSession
          );
        }
      }
    },

    validation() {
      //   if (
      //     this.prodGroupData.group_name != "" &&
      //     this.prodGroupData.product_codes.length > 0
      //   ) {
      //     this.showBtn = true;
      //   } else {
      //     this.showBtn = false;
      //   }
      this.$forceUpdate();
    },
  },

  async mounted() {
    this.roles = await this.$cookies.get("product_group");
    console.log("groupID: ", this.groupID);
    if (this.groupID != undefined) {
      await this.loadData();
      this.validation();
    }
  },
};
</script>

<style lang="scss" scoped>
</style>